import { DateTime } from 'luxon';
import { AddressInfo } from '../../../work-orders/work-order-details/work-order.interfaces';
import { LadingPatch, PanelDetails } from '../work-order-panel.models';
import { contactAddresses } from '../work-order-panel.context';
import { StopAddressValues, StopEditorValues, WorkOrderStopRole } from './work-order-stop.models';

export function stopAddressValues(address?: Partial<AddressInfo> | null): StopAddressValues {
  return {
    address_street: address?.address_street || '',
    address_extended: address?.address_extended || '',
    address_locality: address?.address_locality || '',
    address_region: address?.address_region || '',
    address_postal_code: address?.address_postal_code || '',
    address_country: address?.address_country || '',
    timezone_id: address?.timezone_id || '',
  };
}

export function stopEditorValues(details: PanelDetails, role: WorkOrderStopRole): StopEditorValues {
  const lading = details.lading;
  const selectedId = lading[`${role}_contact_address_uuid`];
  const address = contactAddresses(details[role], selectedId)[0];
  return {
    contact_uuid: lading[`${role}_contact_uuid`] || '',
    contact_address_uuid: selectedId || address?.contact_address_uuid || '',
    name: lading[`${role}_name`] || '',
    hours: (role === 'shipper' ? lading.load_start_hours : lading.load_end_hours) || '',
    ...stopAddressValues(address),
  };
}

export function addressMatches(address: Partial<AddressInfo>, values: StopAddressValues): boolean {
  const original = stopAddressValues(address);
  return (Object.keys(original) as Array<keyof StopAddressValues>).every(
    (field) => original[field].trim() === values[field].trim(),
  );
}

export function stopValidation(values: StopEditorValues): string | null {
  if (!values.contact_uuid) return 'Choose a company from the search results.';
  if (!values.name.trim()) return 'Enter the name to show on this work order.';
  if (!values.address_street.trim()) return 'Enter the street address.';
  if (!values.address_locality.trim()) return 'Enter the city.';
  if (!values.address_country.trim()) return 'Enter the country.';
  if (values.timezone_id && !DateTime.fromISO('2000-01-01', { zone: values.timezone_id }).isValid) {
    return 'Choose a valid timezone.';
  }
  return null;
}

export function stopLadingPatch(
  role: WorkOrderStopRole,
  values: StopEditorValues,
  addressUuid: string,
): LadingPatch {
  return {
    [`${role}_contact_uuid`]: values.contact_uuid,
    [`${role}_contact_address_uuid`]: addressUuid,
    [`${role}_name`]: values.name.trim(),
    [`${role}_locality`]: values.address_locality.trim(),
    [`${role}_region`]: values.address_region.trim(),
    [role === 'shipper' ? 'load_start_hours' : 'load_end_hours']: values.hours.trim() || null,
  };
}
